var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sub-menu-page',{scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('os-app-sub-menu',{attrs:{"menu-items":_vm.items,"menu-header":"Global settings"}})]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }